import axiosInstance from '../lib/axios';
import { API_CONFIG } from '../config/api.config';

export interface ArchiveListParams {
  page?: number;
  limit?: number;
  year?: number;
  case_type?: string;
  search?: string;
}

export const archiveService = {
  getList: (params: ArchiveListParams = {}) =>
    axiosInstance.get('/archive', { params }),

  getTree: (year?: number) =>
    axiosInstance.get('/archive/tree', {
      params: year != null ? { year } : {},
    }),

  unarchive: (documentId: string) =>
    axiosInstance.post(`/archive/${documentId}/unarchive`),

  getDownloadUrl: (documentId: string): string =>
    `${API_CONFIG.BASE_URL}/documents/${documentId}/file?download=true`,
};

export default archiveService;
